import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "w-screen" }
const _hoisted_2 = {
  key: 0,
  class: "flex justify-center w-screen"
}
const _hoisted_3 = { class: "topSection flex justify-between items-center" }
const _hoisted_4 = { class: "textBox" }
const _hoisted_5 = /*#__PURE__*/_createStaticVNode("<p class=\"hello font-black\"> Hello! </p><p class=\"greeting font-bold\"> I&#39;m <span style=\"color:#F9B959;\">Emmett Myers.</span></p><p class=\"desc font-medium\"> I <span class=\"animate\">code </span> websites and mobile apps. </p>", 3)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("div", { class: "meBox relative flex justify-center" }, [
  /*#__PURE__*/_createElementVNode("img", {
    class: "absolute bottom-0 object-cover",
    src: "headshots/emmettHeadshot3.png"
  })
], -1)
const _hoisted_9 = {
  key: 1,
  class: "flex justify-center w-screen"
}
const _hoisted_10 = { class: "topSection" }
const _hoisted_11 = /*#__PURE__*/_createStaticVNode("<div class=\"flex justify-center pt-6\"><div class=\"meBox relative flex justify-center mt-20\"><img class=\"absolute bottom-0 object-cover\" src=\"headshots/emmettHeadshot3.png\"></div></div><p class=\"hello font-black pt-5\"> Hello! </p><p class=\"greeting font-bold\"> I&#39;m <span style=\"color:#F9B959;\">Emmett Myers.</span></p><p class=\"desc font-medium\"> I <span class=\"animate\">code </span> websites and mobile apps. </p>", 4)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ContactIcons = _resolveComponent("ContactIcons")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.screen == 'computer')
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _hoisted_5,
              _createVNode(_component_ContactIcons)
            ]),
            _hoisted_8
          ])
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_9, [
          _createElementVNode("div", _hoisted_10, [
            _hoisted_11,
            _createVNode(_component_ContactIcons)
          ])
        ]))
  ]))
}